import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import download from 'downloadjs'
import CryptoJS from 'crypto-js';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'


export default {
	name: 'sales-report',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			// currentPage: 0,
			// totalRows:0,
			// perPage: 10,
			// pageno: 0,
			// totalPage: 0,
			sLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			listSalesReportData: [],
			listMerchantData: [],
			listshippingcompanyData: [],
			listwarehouseidData: [],
			csvFields: [],
			listReportDatacsv: [],
			formattedDate: '',
			fromdate: '',
			todate: '',
			localwarehouseid: '',
			orderid: '',
			invoiceid: '',
			clientproductid: '',
			shippingcompanyname: '',
			isLoading: false,
			resultCount: '',
			listClientData: [],
			client: '',
			warehouse: '',
			ClientErr: '',
			listWarehouseData: [],
			warehouseid: '',
			WarehouseErr: '',
			merchantname: '',
			showSelectWarehouse: false,
			showSelectMerchant: false,
			searchFlag: false,
			showSelectClient: false,
			userid: '',
			isLoadingforxls: false,
			recordLimit: 0,
			limitExeed: false,
			searchbtoborder: '',
			manifestid: '',
			item: {},
			merchant: '',
			listMerchantData1: [],
			merchantList: [],
			merchantname: '',
			activemrpflag:false,
			rtvType:''
		}
	},
	computed: {},
	mounted() {
		this.calldateFunction();
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.reportname = this.$t('editedjson.salesReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.userid = userdetail.userid;
		this.localwarehouseid = userdetail.warehouseid
		this.localclientid = userdetail.clientid,
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantList();
		this.getshippingData();
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getshippingData();
		  });
			this.pageno = 0,
			// this.getClientList();
			//this.getSalesReportData();
			//this.getwarehouseData();
			//this.getshippingData();
			this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.showSelectWarehouse = true;
				this.client = this.clientid;
				this.showSelectMerchant = true
				// this.getWarehouseList();
				this.getMerchantList();
				this.getActiveMrpFlag();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchantname = this.mid
					this.showSelectMerchant = false
				}
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();

				break;

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;
			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
	},

	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchantname = item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 7);
			this.fromdate = dt;
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getSalesReportDataForXLS(3)
			}
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 				// this.getshippingData();
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantname = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {

		// 			if (this.warehouseid != '' && this.clientid != '') {
		// 				this.getshippingData();
		// 				this.getMerchantList();
		// 				this.getActiveMrpFlag();
		// 				this.item = {}
		// 			}

		// 			// this.getPickingReportList();
		// 		}
		// 	}

		// 	this.listSalesReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },
		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getshippingData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		async getActiveMrpFlag(){
				 var userToken = window.localStorage.getItem('userToken');
				 var myStr = userToken.replace(/"/g, '');
				 this.input = ({
					 "clientid": localStorage.getItem('selectedClient'),
				 });
			 try {

					 axios({
							 method: 'POST',
							 'url': apiUrl.api_url + 'checkActivemrpFlg',
							 'data': this.input,
							 headers: {
								 'Authorization': 'Bearer ' + myStr,
							 }
						 })
						 .then(result => {
							 if(result.data.data.data[0].value ==='yes'){
								 this.activemrpflag = true;
							 }else{
								 this.activemrpflag = false;
							 }
						 }, error => {
							 console.error(error);
						 });

				 } catch (err) {
					 throw new Error(err);
				 }
	 },
		getshippingData() {
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError')
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: localStorage.getItem('selectedWarehouse'),
				clientid: localStorage.getItem('selectedClient'),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'shippingDetails',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listshippingcompanyData = result.data.data
				}, error => {
					console.error(error)
				})
		},
		getMerchantList() {
			this.listMerchantData1 = []
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantlistArray = [];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
						result.data.forEach(function (item) {
							merchantlistArray[item.merchantid] = item.merchantname;

						})
						this.merchantList = merchantlistArray;
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}

				}, error => {
					console.error(error)
				})
		},
		getSalesReportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getSalesReportData(2);
		},
		//to get Sales Report list
		getSalesReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			var dataFilter = {};
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.listData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.listData = [];
				return false;
			}
			if (this.orderid == '' && (this.fromdate == '' || this.fromdate == null) && (this.todate == '' || this.todate == null)) {
				this.$alertify.error(this.$t('common.selectTimeFrameError'));
				this.pageNo = this.totalPage = 0;
				this.listSalesReportData = [];
				this.totalRows = 0;
				return false;
			}
			var months;
			var fromDate = new Date(this.fromdate);
			var ToDate = new Date(this.todate);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))
			if (this.orderid == '' && months > 3) {
				this.$alertify.error(this.$t('common.selectTimeFrameError'));
				this.pageNo = this.totalPage = 0;
				this.listSalesReportData = [];
				this.totalRows = 0;
				return false;
			}

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate)
			}
			this.isLoading = true
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat2(this.todate)
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				fromddate: fr_date,
				todate: to_date,
				warehouseid: localStorage.getItem('selectedWarehouse'),
				orderid: this.orderid,
				invoicenumber: this.invoiceid,
				clientproductid: this.clientproductid,
				shippingcompany: this.shippingcompanyname,
				csvData: csvCheck,
				clientid: localStorage.getItem('selectedClient'),
				merchantid: this.merchantname,
				userid: this.userid,
				searchbtoborder: this.searchbtoborder,
				rtvType:this.rtvType
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			// if (csvCheck == 1) {
			// 	this.isLoading = true;
			// }
			if (localStorage.getItem('selectedClient') != '') {
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'salesReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						if (csvCheck == 1) {
							if (result.data.data.length > 0) {
								this.show = true;
								this.download = false;
								this.csvFields = {
									'orderid': this.$t('common.orderID'),
									'itemid': this.$t('packingReportList.table.columns.orderItemId'),
									'clientproductid': this.$t('product.clientProductId'),
									'productname': this.$t('product.productName'),
									'productqty': this.$t('cancelPutawayPendingReport.productQty'),
									'mrp': this.$t('removeHold.productMrp'),
									'activemrp': this.$t('common.activemrp'),
									'createddatetime': this.$t('salesreport.orderdatetime'),
									'boxid': this.$t('common.boxId'),
									'shippingcompany': this.$t('common.courierCompany'),
									'awbno': this.$t('common.awbNo'),
									'dispatcheddatetime': this.$t('salesreport.handoverdatetime'),
									'warehouseid': this.$t('warehouses.warehouseName'),
									// 'dispatchedbyuser': 'Handover By',
									'saleschannel': this.$t('common.salesChannel'),
									'merchantname': this.$t('common.merchantName'),
									'manifestid': this.$t('common.manifestid')

								};
								var dateFilter = [];
								if(this.activemrpflag === true){
									var skipFilter = ['Handoverdatetime', 'lotcontrol', 'invoicenumber', 'shippingval', 'dispatchedbyuser', 'rowcount'];
								}else {
									var skipFilter = ['Handoverdatetime', 'lotcontrol', 'invoicenumber', 'shippingval', 'dispatchedbyuser', 'rowcount','activemrp'];
								}
								this.listSalesReportDataCsv = result.data.data;
								csvHelper.data.jsonToCSV(this.$t('editedjson.salesReport'), this.listSalesReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

								// this.jsonToCSV('salesReport', this.listSalesReportDataCsv, this.csvFields, dateFilter, skipFilter);
							} else {
								if (result.data.status == true) {
									this.$alertify.success(this.$t('common.reportSizeError'));
								} else {
									this.$alertify.error(result.data.msg.message);
								}
							}
						} else {
							this.listSalesReportData = result.data.data
							if (result.data.errorCode == -1) {
								this.resultCount = 0
							} else {
								this.totalRows = result.data.count
								this.resultCount = result.data.count
								if (Number(this.totalRows) > Number(this.recordLimit)) {
									this.limitExeed = true
								}

								if (this.totalRows < this.pageLimit) {
									this.totalPage = 1;
								} else {
									this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
								}
							}

						}
						this.isLoading = false;
					}, error => {
						console.error(error)
					})
			} else {
				this.ClientErr = this.$t('common.clientError');
			}
		},
		getSalesReportDataForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate)
			}

			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat2(this.todate)
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				fromddate: fr_date,
				todate: to_date,
				warehouseid: localStorage.getItem('selectedWarehouse'),
				orderid: this.orderid,
				invoicenumber: this.invoiceid,
				clientproductid: this.clientproductid,
				shippingcompany: this.shippingcompanyname,
				csvData: csvCheck,
				clientid: localStorage.getItem('selectedClient'),
				merchantid: this.merchantname,
				userid: this.userid,
				searchbtoborder: this.searchbtoborder,
				rtvType:this.rtvType
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			// if (csvCheck == 1) {
			// 	this.isLoading = true;
			// }
			if (localStorage.getItem('selectedClient') != '') {
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'salesReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						if (csvCheck == 3) {
							if (result.data.data.length > 0) {
								this.listReportDataforxls = [];
								this.csvFieldsForXls[this.$t('common.orderID')] = 'orderid';
								this.csvFieldsForXls[this.$t('packingReportList.table.columns.orderItemId')] = 'itemid';
								this.csvFieldsForXls[this.$t('product.clientProductId')] = 'clientproductid';
								this.csvFieldsForXls[this.$t('product.productName')] = 'productname';
                                this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.productQty')] = 'productqty';
								this.csvFieldsForXls[this.$t('removeHold.productMrp')] = 'mrp';
								if(this.activemrpflag === true){
									this.csvFieldsForXls[this.$t('common.activemrp')] = 'activemrp';
								}
								this.csvFieldsForXls[this.$t('salesreport.orderdatetime')] = 'createddatetime';
								this.csvFieldsForXls[this.$t('common.boxId')] = 'boxid';
								this.csvFieldsForXls[this.$t('common.courierCompany')] = 'shippingcompany';
								this.csvFieldsForXls[this.$t('common.awbNo')] = 'awbno';
								this.csvFieldsForXls[this.$t('salesreport.handoverdatetime')] = 'dispatcheddatetime';
								this.csvFieldsForXls[this.$t('warehouses.warehouseName')] = 'warehouseid';
								this.csvFieldsForXls[this.$t('common.salesChannel')] = 'saleschannel';
								this.csvFieldsForXls[this.$t('common.merchantName')] = 'merchantname';
								this.csvFieldsForXls[this.$t('common.manifestid')] = 'manifestid';
								this.listReportDataforxls = result.data.data;
							} else {
								if (result.data.status == true) {
									this.$alertify.success(this.$t('common.reportSizeError'));
								} else {
									this.$alertify.error(result.data.msg.message);
								}
							}
						}


					}, error => {
						console.error(error)
					})
			} else {
				this.ClientErr = this.$t('common.clientError');;
			}
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage;
		// 	this.getSalesReportData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getSalesReportData()
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD 00:00:00');
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD 23:59:00');
		},
		//to reset search form
		resetSearchForm() {
			this.show = false;
			this.download = true;
			this.ClientErr = '';
			this.$validator.reset();
			this.fromdate = '';
			this.todate = '';
			this.orderid = '';
			this.merchantname = '',
				this.invoiceid = '';
			this.totalRows = 0;
			this.clientproductid = '';
			this.item = {};
			this.listSalesReportData = [];
			this.shippingcompanyname = '';
			this.searchFlag = false;
			this.rtvType='';
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }

		},
		//validate all form fields on onsubmit()
		onSubmit: function (event) {
			this.$validator.validateAll().then(() => {
				event.target.reset();
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/salesReport/salesReport.component.js